import { get, useFormContext } from "react-hook-form";

import { InputField } from "@components/Field";
import { FieldProps } from "@components/Field/Field/InputField";

const Name = ({
  name = "name",
  required = false,
  ...props
}: Partial<FieldProps>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <InputField
      block
      placeholder={L.ACTIVATE_NAME_PLACEHOLDER}
      label={L.ACTIVATE_NAME_LABEL}
      type="text"
      errorMessage={get(errors, name)?.message}
      {...props}
      {...register(name, {
        required: { value: required, message: L.REQUIRED_FIELD_VALUE },
        pattern: {
          value: /.+\s.+/g,
          message: L.ACTIVATE_LAST_NAME_MISSING,
        },
      })}
    />
  );
};

export { Name };
